import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const WritingWorkshops = () => <EventCategoryPage config={EVENT_CATEGORIES['writing-workshops']} data-id="element-9191" data-mp="2s8f53yba37qs" />;
export default WritingWorkshops;